<template>
    <div class="paths container-fluid d-flex flex-column" v-if="! is_busy">

        <div class="alert alert-danger" v-if="utils.errors(errors, 'path').length" >{{ utils.errors(errors, 'path').join(', ') }}</div>

        <div class="row align-items-stretch justify-content-center d-flex flex-grow-1">

            <div v-for="path in paths" class="col-sm-6 col-md-4 d-flex">
                <div class="card mb-4 w-100">

                    <a :href="route('project.learning-path.show', {path: path.id, ...global_url_params})" target="_blank">
                        <img v-if="path.meta?.image?.preview_url" class="card-img" :src="uploads.image(path.meta.image.preview_url, {w: 480, h: 240})">
                        <img v-else class="card-img" src="https://via.placeholder.com/480x240?text=NO+PREVIEW">
                    </a>
                    <div class="card-header">
                        <h5 class="my-1">{{ path.name }}</h5>
                    </div>
                    <div class="card-body">
                        <markdown-text :content="path.meta?.description"/>
                    </div>
                    <div class="card-footer d-flex justify-content-center">
                        <button class="btn mr-1 btn-primary"
                                @click="selectPath(path.id)">
                            {{ selected_path_id === path.id ? 'Select' : 'Select' }}
                        </button>
                        <a class="btn btn-secondary" target="_blank" :href="route('project.learning-path.show', {path: path.id, ...global_url_params})">Preview</a>
                    </div>
                </div>
            </div>

<!--            <div class="col-sm-6 col-md-4" v-for="path in paths" :key="path.id">-->
<!--                <div class="card text-center" :class="{selected: isSelected( path )}">-->
<!--                    <div class="card-header">-->
<!--                        <h4>{{ path.name }}</h4>-->
<!--                    </div>-->
<!--                    <div class="card-footer">-->
<!--                        <button class="btn mr-1 btn-primary"-->
<!--                                @click="selected_path_id = path.id">-->
<!--                            {{ selected_path_id === path.id ? 'Selected' : 'Select' }}-->
<!--                        </button>-->
<!--                        <a class="btn btn-secondary" target="_blank" :href="route('project.learning-path.show', {path: path.id})">Preview</a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->


        </div>

    </div>
</template>

<script>
import MarkdownText from "@/Components/Common/MarkdownText";
import API from "@/API";
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";

export default {
    name: "SelectPath",
    components: {MarkdownText},
    props: ['errors', 'value'],
    emits: ['update'],
    mixins: [utils, uploads],

    data(){
        return {
            is_busy: true,
            paths: [],
            selected_path_id: null
        }
    },

    watch: {
        selected_path_id(id){
            // if( this.is_busy ) return;
            // this.$emit('update', {id});
        }
    },

    methods: {
        async fetchLearningPaths(){
            this.paths = await API.learning_paths.bulk({tenant_id: this.active_tenant?.id});
        },

        isSelected(path){
            return this.selected_path_id === path.id;
        },

        selectPath(id){
            this.selected_path_id = id;
            this.$emit('update', {id});
        }
    },

    beforeMount() {
        this.selected_path_id = this.value?.id;
    },

    async mounted() {
        this.is_busy = true;
        await this.fetchLearningPaths();
        this.is_busy = false;
    }
}
</script>

<style lang="scss" scoped>
.paths{
    min-height: 50vh;
}
.card{
    &.selected{
        > * {
            background-color: $success;
            color: white;
        }
    }
}
</style>
